module.exports = __webpack_public_path__ + "static/img/3.42d6b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/03/2/3.png
// module id = dTTq
// module chunks = 2